import script from "./fiveStep.vue?vue&type=script&setup=true&lang=js"
export * from "./fiveStep.vue?vue&type=script&setup=true&lang=js"

import "./fiveStep.vue?vue&type=style&index=0&id=4d5b29fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_354139e77772094841bf527df78bd682/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d5b29fd"]])

export default __exports__